import React from "react";
import { InputGroup, Input as ChakraInput, InputLeftElement, Icon, } from "@chakra-ui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
export function SearchInput({ placeholder, value, width = "xs", onChange, ...props }) {
    return (React.createElement(InputGroup, { width: width, maxWidth: "100%", ...props },
        React.createElement(InputLeftElement, { pointerEvents: "none" },
            React.createElement(Icon, { as: MagnifyingGlassIcon, boxSize: 4 })),
        React.createElement(ChakraInput, { focusBorderColor: "brand.400", type: "search", placeholder: placeholder, value: value, onChange: onChange })));
}
